import { render, staticRenderFns } from "./MilkFeedingReport.vue?vue&type=template&id=84d573c0&scoped=true&"
import script from "./MilkFeedingReport.vue?vue&type=script&lang=js&"
export * from "./MilkFeedingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d573c0",
  null
  
)

export default component.exports